import React, { FC, useEffect, useMemo, useState } from "react";
import { FormBaseType } from "@green0meter/api-client";
import { isEmpty } from "lodash";

import BuyerHubReports from "./BuyerHubReports";

import { useGetProcurementSuppliersReportsMetadata } from "@api";
import { CardTable, DeleteReportButton, DownloadButton } from "@components/common";
import { useUserStore } from "@store/user";
import { formatDateUtc } from "@helpers";
import { Box } from "@components/base";

const columns: CardTable["columns"] = [
  {
    field: "name",
    title: "common.fileName",
    tableProps: {
      sx: {
        minWidth: 120,
      },
    },
  },
  {
    field: "procurementSupplierName",
    title: "sellers.entityName",
    tableProps: {
      sx: {
        minWidth: 150,
      },
    },
  },
  {
    field: "createdAt",
    title: "common.date",
    tableProps: {
      width: 150,
    },
  },
  {
    field: "action",
    title: "common.action",
    tableProps: {
      sx: {
        width: 220,
      },
    },
  },
];

const BuyerHubReportsContainer: FC<{ formBaseType: FormBaseType }> = ({
  formBaseType,
}) => {
  const { user } = useUserStore();

  const params = useMemo(() => ({ formBaseTypes: [formBaseType] }), [formBaseType]);
  const { reportsMetadata, reportsMetadataEnabled, isSuccessReports } =
    useGetProcurementSuppliersReportsMetadata(user, params);

  const [rows, setRows] = useState<CardTable["rows"]>([]);

  useEffect(() => {
    if (reportsMetadata && !isEmpty(reportsMetadata)) {
      const _rows = reportsMetadata.map((report) => {
        return {
          name: report.name,
          procurementSupplierName: report.procurementSupplierName,
          createdAt: formatDateUtc(report.createdAt),
          action: [
            <Box display={"flex"} gap={1}>
              <DownloadButton report={report} isBuyer={true} />
              {!report.procurementSupplierName && (
                <DeleteReportButton report={report} />
              )}
            </Box>,
          ],
        };
      });

      setRows(_rows);
    }
  }, [reportsMetadata]);

  return (
    reportsMetadataEnabled && (
      <BuyerHubReports columns={columns} rows={rows} isLoaded={isSuccessReports} />
    )
  );
};

export default BuyerHubReportsContainer;
